import api from './api';
import TokenService from './token.service';
import Cookies from 'js-cookie';

const TERMOS_CACHE_KEY = 'termos_ultima_verificacao';

/**
 * Limpa todos os dados relacionados a programas armazenados no localStorage
 */
const clearProgramStorage = () => {
    const keysToRemove = [];
    
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (
            key.startsWith('programa_logomarca_') ||
            key.startsWith('programa_nome_') ||
            key.startsWith('programa_ocultar_') ||
            key.startsWith('programa_logomarca_timestamp_')
        )) {
            keysToRemove.push(key);
        }
    }
    
    keysToRemove.forEach(key => localStorage.removeItem(key));
};

/**
 * Limpa o cache de verificação de termos
 */
const clearTermsCache = () => {
    localStorage.removeItem(TERMOS_CACHE_KEY);
};

/**
 * Limpa o GlobalContext armazenado
 */
const clearGlobalContext = () => {
    localStorage.removeItem('globalContextValue');
};

/**
 * Realiza a troca completa de programa com limpeza de storages
 * @param {string} username - Nome de usuário
 * @param {string} password - Senha
 * @param {object} targetProgram - Objeto do programa alvo contendo { uuid, nome, id }
 * @param {function} setGlobalValue - Função do GlobalContext para atualizar contexto
 * @returns {Promise<object>} - Retorna os dados da resposta da API
 */
const performProgramSwitch = async (username, password, targetProgram, setGlobalValue) => {

    const payload = {
        username: username,
        password: password,
        programa_uuid: targetProgram?.uuid
    };

    const response = await api.post('/login/', payload);
    const response_api = response.data;

    TokenService.removeUser();
    clearTermsCache();
    clearGlobalContext();
    clearProgramStorage();

    if (targetProgram?.uuid) {
        Cookies.set("p_login", targetProgram.uuid, { secure: true, sameSite: 'Strict', path: '/' });
    }

    if (response_api.ambiente_programa_id && targetProgram?.nome) {
        localStorage.setItem(`programa_nome_${response_api.ambiente_programa_id}`, targetProgram.nome);
    }

    TokenService.setUser(response_api);

    if (setGlobalValue) {
        const { access, refresh, ...userWithoutTokens } = response_api;
        setGlobalValue({
            user: userWithoutTokens,
            programaId: targetProgram?.uuid || null,
            timestamp: new Date().getTime()
        });
    }

    return response_api;
};

const performProgramSwitchSSO = async (targetProgram, setGlobalValue) => {

    const payload = {
        programa_uuid: targetProgram?.uuid
    };

    const response = await api.post('/login/sso/', payload);
    const response_api = response.data;

    TokenService.removeUser();
    clearTermsCache();
    clearProgramStorage();

    if (targetProgram?.uuid) {
        Cookies.set("p_login", targetProgram.uuid, { secure: true, sameSite: 'Strict', path: '/' });
    }

    if (response_api.ambiente_programa_id && targetProgram?.nome) {
        localStorage.setItem(`programa_nome_${response_api.ambiente_programa_id}`, targetProgram.nome);
    }

    TokenService.setUser(response_api);

    const { access, refresh, ...userWithoutTokens } = response_api;
    const globalContextPayload = {
        user: userWithoutTokens,
        programaId: targetProgram?.uuid || null,
        timestamp: new Date().getTime()
    };
    localStorage.setItem('globalContextValue', JSON.stringify(globalContextPayload));

    if (setGlobalValue) {
        setGlobalValue(globalContextPayload);
    }

    return response_api;
};

const programSwitchService = {
    clearProgramStorage,
    clearTermsCache,
    clearGlobalContext,
    performProgramSwitch,
    performProgramSwitchSSO,
};

export default programSwitchService;
